import React from "react";
import { number, func, array } from "prop-types";

import "./subscription-plans.m.css";

const SubscribePlans = ({ selectedIndex, setSelectedIndex, plans, recommendedId }) => {
  if (!plans.length) return null;

  const onItemClick = (index) => (e) => setSelectedIndex(index);

  const currencyDictionary = { INR: "Rs", USD: "$" };

  const totalAmount = {
    "162000": 1800,
    "450000": 5000,
    "45000": 500,
  };

  return (
    <div styleName="wrapper" className="container">
      {plans.map((item, index) => (
        <div
          styleName={index === selectedIndex ? "content-selected" : "content"}
          onClick={onItemClick(index)}
          key={item.id}
        >
          <span styleName="headline-label">{item.title}</span>
          <div styleName={index === selectedIndex ? "price-wrapper-selected" : "price-wrapper"}>
            <span styleName="currency-type">{currencyDictionary[item.price_currency]}</span>
            <span styleName="total-amount"> {totalAmount[`${item.price_cents}`]}</span>
            <span styleName="discount-amount">{item.price_cents / 100}</span>
          </div>
          <span styleName="type">{item.description}</span>

          {item.id === recommendedId ? <div styleName="recommended-view">Recommended</div> : null}
        </div>
      ))}
    </div>
  );
};

SubscribePlans.propTypes = {
  selectedIndex: number,
  setSelectedIndex: func,
  plans: array,
  recommendedId: number,
};

export default SubscribePlans;
